import React, { useEffect, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataView } from "primereact/dataview";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import './Dashboard.css';

function Pharmacy({ selectedCase, refresh }) {

 

    const { caseType } = useParams()
    const { token } = useParams();
    const { caseid } = useParams();
    const { refillid } = useParams();
    const { pharmacyidParam } = useParams();
 
    const navigate = useNavigate();
    const [{ user, stateList }, dispatch] = useStateValue();
    const [pharmacy, setPharmacy] = useState(null);
    const [selectedPharmacy, setSelectPharmacy] = useState(null);
    const [pharmacyError, setPharmacyError] = useState(null);
    const [pharmacyList, setPharmacyList] = useState([]);
    const [filters, setFilters] = useState({
        name: "",
        city: "",
        state: "",
        zip: "",
        pageNumber: 1,
    });

    const [globalFilter, setGlobalFilter] = useState("");
    const [pharmacyid, setPharmacyid] = useState(null);
   
    useEffect(() => {
        if (typeof selectedCase !== 'undefined') {

            setPharmacyid(selectedCase.pharmacy_id);
        }
        else {
            setPharmacyid(pharmacyidParam);

        }
    }, [selectedCase])

    useEffect(() => {
        if (pharmacyid !== null)
            callDoseSpot();
    }, [pharmacyid])


    //useEffect(() => {
    //    if (pharmacyid) callDoseSpot();
    //}, [pharmacyid]);

    const callDoseSpot = () => {
        const url = "/api/doseSpot/PharmacyInfo";
        const params = { PharmacyID: pharmacyid };

        axios
            .post(url, params)
            .then((response) => {
                if (response.status === 200) {
                    const pharmacy = JSON.parse(response.data.Pharmacy);
                   // "Pharmacy": "{\"Item\":null,\"Result\":{\"ResultCode\":\"ERROR\",\"ResultDescription\":\"Property: PharmacyID Details: PharmacyID 51115 is inactive. Please select another pharmacy.\"}}"
                    if (pharmacy.Item === null)
                    {
                        setPharmacyError(pharmacy.Result.ResultDescription);
                    }
                    else
                    {
                        setPharmacy(pharmacy.Item);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Error fetching pharmacy info.");
            });
    };

    const searchPharmacy = () => {
        const url = "/api/doseSpot/PharmacySearch";
        const params = { ...filters };

        axios
            .post(url, params)
            .then((response) => {
                if (response.status === 200) {
                    const pharmacyData = JSON.parse(response.data.PharmacyList);
                    setPharmacyList(pharmacyData.Items);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Error searching for pharmacies.");
            });
    };

    const changePharmacy = (selectedPharmacy) => {
        setPharmacyError(null);
        setSelectPharmacy(selectedPharmacy);
        };

    const filteredPharmacyList = pharmacyList.filter((pharmacy) =>
        Object.values(pharmacy).some((value) =>
            value?.toString().toLowerCase().includes(globalFilter.toLowerCase())
        )
    );

    const renderPharmacyItem = (pharmacy) => (
        <Card className="p-3 mb-3 shadow-sm">
            <h5>{pharmacy.StoreName}</h5>
            <p>
                <strong>Phone:</strong> {pharmacy.PrimaryPhone} <br />
                <strong>Address:</strong> {pharmacy.Address1} {pharmacy.Address2}
                <br />
                {pharmacy.City}, {pharmacy.State} {pharmacy.ZipCode}
            </p>
            <Button
                label="Select Pharmacy"
                className="p-button-sm p-button-warning"
                onClick={() => changePharmacy(pharmacy)}
            />
        </Card>
    );

    const saveChanges = (e) => {
        e.preventDefault();

        let state = stateList.filter(
            state => state.name.toUpperCase() === selectedPharmacy.State.toUpperCase()
        );
          
            const url = "/api/ha/SaveChanges";

            const params = {
                actionType: 'UpdatePharmacy',
                casetype: selectedCase.casetype.toLowerCase(),
                caseID: selectedCase.id,
                refillID: selectedCase.refillID,
                pharmacy_id: selectedPharmacy.PharmacyId,
                pharmacy_state_id: state && state[0].value,
                pharmacy_zip: selectedPharmacy.ZipCode
            };

            axios
                .post(url, params)
                .then((response) => {
                    if (response.data.status === 'OK') {
                        setPharmacy(selectedPharmacy);
                        setSelectPharmacy(null);
                        refresh();
                        alert("saved successfully!");
                    }
                    else {
                        alert(response.data.errMsg);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    alert("Error:" + error);
                });
        
    };

    return (
        <div className="mt-0 ">
            
            {/* Selected Pharmacy Info */}
           
                <div className="mt-0">
                {

                    selectedCase &&
                    <div className="display-6">
                            {selectedCase.first_name && <span className="fs-2"> {selectedCase.first_name} {selectedCase.middle_initial} {selectedCase.last_name} - {selectedCase.pharmacy_state}  </span>}
                        <span className="ml-3 fs-4">Token:{selectedCase.token} {selectedCase.casetype === 'Case' ? 'Case:' + selectedCase.id : 'Refill:' + selectedCase.refillID} Status: {selectedCase.status}</span>
                    </div>
                }
                <hr />
                <div className="d-flex">
                    <div className="card shadow-lg" style={{ minWidth: '400px', maxWidth: '500px' }}>
                        <div className="card-header bg-success text-white">Active Pharmacy</div>
                        <div className="card-body">
                        {pharmacyError !== null ?
                            <h6 style={{ color: 'red' }}>{pharmacyError}</h6>
                            : pharmacy ? (
                                <>
                                    <h5>{pharmacy.StoreName}</h5>
                                    <div><strong>PharmacyId:</strong> {pharmacy.PharmacyId}</div>
                                    <div><strong>Phone:</strong> {pharmacy.PrimaryPhone}</div>
                                    <div><strong>Address:</strong> {pharmacy.Address1} {pharmacy.Address2}  <br />{pharmacy.City} {pharmacy.State} {pharmacy.ZipCode}</div>


                                </>
                            ) : (
                                <p>Loading pharmacy info...</p>
                            )}
                        </div>
                </div>
                {selectedPharmacy ?
                        <div className="card shadow-lg ml-4" style={{ minWidth: '400px',maxWidth: '500px' }}>
                        <div className="card-header bg-warning text-white">Selected Pharmacy</div>
                        <div className="card-body">
                            {pharmacyError !== null ?
                                <h6 style={{ color: 'red' }}>{pharmacyError}</h6>
                                : selectedPharmacy ? (
                                    <>
                                        <h5>{selectedPharmacy.StoreName}</h5>
                                        <div><strong>PharmacyId:</strong> {selectedPharmacy.PharmacyId}</div>
                                        <div><strong>Phone:</strong> {selectedPharmacy.PrimaryPhone}</div>
                                            <div><strong>Address:</strong> {selectedPharmacy.Address1} {selectedPharmacy.Address2}  <br />{selectedPharmacy.City} {selectedPharmacy.State} {selectedPharmacy.ZipCode}</div>

                                            <div><button type="button" className="btn btn-primary mt-3" onClick={saveChanges}>Save Changes</button></div>
                                    </>
                                ) : (
                                    <p>Loading pharmacy info...</p>
                                )}
                        </div>
                    </div>
                    : null
                }
                </div>
            </div>
          
            {/* Search Filters */}
           
            <div className="card p-4 shadow mt-4">
                <h6 className="text-left mb-4">Pharmacy Search</h6>
                <div className="row g-3">
                    <div className="col-md-3">
                        <InputText
                            className="form-control"
                            placeholder="Pharmacy Name"
                            value={filters.name}
                            onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                        />
                    </div>
                    <div className="col-md-3">
                        <InputText
                            className="form-control"
                            placeholder="ZIP Code"
                            value={filters.zip}
                            onChange={(e) => setFilters({ ...filters, zip: e.target.value })}
                        />
                    </div>
                    <div className="col-md-3">
                        <InputText
                            className="form-control"
                            placeholder="City"
                            value={filters.city}
                            onChange={(e) => setFilters({ ...filters, city: e.target.value })}
                        />
                    </div>
                    <div className="col-md-3">
                        <InputText
                            className="form-control"
                            placeholder="State"
                            value={filters.city}
                            onChange={(e) => setFilters({ ...filters, state: e.value })}
                        />

                    </div>

                    <div className="col-md-12 text-center mt-3">
                        <Button label="Search" className="p-button-success" onClick={searchPharmacy} />
                    </div>
                </div>
            </div>

            {/* Global Search Filter */}
            {filteredPharmacyList.length > 0 ?
                <>
            <div className="mt-4">
                <InputText
                    className="form-control"
                    placeholder="Search in results..."
                    value={globalFilter}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                />
            </div>
            

                < div className="mt-4">
                    <h4>Search Results</h4>
                    {filteredPharmacyList.length > 0 ? (
                            <DataView value={filteredPharmacyList} itemTemplate={renderPharmacyItem}  />
                    ) : (
                        <p className="text-muted">No pharmacies found. Try adjusting your filters.</p>
                    )}
                    </div>
                </>
                    : null
              
            }
          
        </div>
    );

}
export default Pharmacy;